import { useEffect, useState } from "react";

interface TimezoneInfo {
    locale: string;
    timezone: string;
}

function useLocalTimezone(): TimezoneInfo {
    const [timezoneInfo, setTimezoneInfo] = useState<TimezoneInfo>({
        locale: "en-US",
        timezone: "America/New_York",
    });

    useEffect(
        () =>
            setTimezoneInfo({
                locale: timezoneInfo.locale,
                timezone:
                    // eslint-disable-next-line
                    Intl.DateTimeFormat().resolvedOptions().timeZone ||
                    timezoneInfo.timezone,
            }),
        []
    );

    return timezoneInfo;
}

export default useLocalTimezone;
